/* What happened while the conversation was collapsed: a dot under the expand button. */
.news {
  display: inline-flex;
  min-block-size: 8px;
}

.dot {
  inline-size: 8px;
  block-size: 8px;
  border-radius: 50%;
  background: var(--focus-ring);
}

.dot[data-busy="true"] {
  animation: pulse 1.2s var(--motion-ease) infinite;
}

@media (prefers-reduced-motion: reduce) {
  .dot[data-busy="true"] {
    animation: none;
  }
}

@keyframes pulse {
  50% {
    opacity: 0.35;
  }
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
